class Dependent {
  constructor() {
    this.memberOID = [];
    this.memberSeqID = [];
    this.firstName = [];
    this.lastName = [];
    this.middleName = [];
    this.dependentLink = [];
    this.relationshipToMember = [];
  }

  getMemberOID(iIndex) {
    return this.memberOID[iIndex];
  }

  setMemberOID(iIndex, memberOID) {
    this.memberOID[iIndex] = memberOID;
  }

  getMemberSeqID(iIndex) {
    return this.memberSeqID[iIndex];
  }

  setMemberSeqID(iIndex, memberSeqID) {
    this.memberSeqID[iIndex] = memberSeqID;
  }

  getFirstName(iIndex) {
    return this.firstName[iIndex];
  }

  setFirstName(iIndex, firstName) {
    this.firstName[iIndex] = firstName;
  }

  getLastName(iIndex) {
    return this.lastName[iIndex];
  }

  setLastName(iIndex, lastName) {
    this.lastName[iIndex] = lastName;
  }

  getMiddleName(iIndex) {
    return this.middleName[iIndex];
  }

  setMiddleName(iIndex, middleName) {
    this.middleName[iIndex] = middleName;
  }

  getDependentLink(iIndex) {
    return this.dependentLink[iIndex];
  }

  setDependentLink(iIndex, dependentLink) {
    this.dependentLink[iIndex] = dependentLink;
  }

  getRelationshipToMember(iIndex) {
    return this.relationshipToMember[iIndex];
  }

  setRelationshipToMember(iIndex, relationshipToMember) {
    this.relationshipToMember[iIndex] = relationshipToMember;
  }

  resetDependent() {
    this.memberSeqID = [];
    this.firstName = [];
    this.lastName = [];
    this.middleName = [];
    this.dependentLink = [];
    this.relationshipToMember = [];
  }
}

export default new Dependent();
